var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vm-modal"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('configuration.paywayGroups.alior.aliorModal.text1'))}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('configuration.paywayGroups.alior.aliorModal.text2'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }